// Define user groups
export const USER_GROUPS = {
    MASTER: 'Master',
    ADMIN: 'Admin',
    ATENDIMENTOS: 'Atendimentos',
    CAIXA: 'Caixa',
    PROFISSIONAL: 'Profissional'
};

// Define route permissions
export const ROUTE_PERMISSIONS = {
    dashboard: [USER_GROUPS.ADMIN, USER_GROUPS.ATENDIMENTOS, USER_GROUPS.CAIXA],
    anamnese: [USER_GROUPS.ADMIN],
    historico: [USER_GROUPS.ADMIN],
    protocolo: [USER_GROUPS.ADMIN],
    agenda: [USER_GROUPS.ADMIN, USER_GROUPS.ATENDIMENTOS, USER_GROUPS.CAIXA, USER_GROUPS.PROFISSIONAL],
    pacientes: [USER_GROUPS.ADMIN, USER_GROUPS.ATENDIMENTOS, USER_GROUPS.CAIXA],
    prontuario: [USER_GROUPS.ADMIN],
    financeiro: [USER_GROUPS.ADMIN, USER_GROUPS.CAIXA],
    cashflow: [USER_GROUPS.ADMIN],
    config: [USER_GROUPS.ADMIN, USER_GROUPS.CAIXA, USER_GROUPS.ATENDIMENTOS],
    estoque: [USER_GROUPS.ADMIN, USER_GROUPS.CAIXA],
    reports: [USER_GROUPS.ADMIN, USER_GROUPS.CAIXA],

    users: [USER_GROUPS.MASTER],
    nexusai: [USER_GROUPS.ADMIN, USER_GROUPS.ATENDIMENTOS, USER_GROUPS.CAIXA]
};

// Define professionals to exclude from commission payments
export const EXCLUDED_FROM_COMMISSION = {
    professionalIds: ["1", "7"]
}; 